export const messages = {
  en: {
    auditEnterCommunity: {
      title: 'Merchant Audit',
      queryConditions: 'Query Conditions',
      merchantName: 'Merchant Name',
      communityName: 'Community Name',
      auditStatus: 'Audit Status',
      search: 'Search',
      more: 'More',
      hide: 'Hide',
      merchantType: 'Merchant Type',
      contactNumber: 'Contact Number',
      merchantAudit: 'Merchant Audit',
      communityId: 'Community ID',
      merchantTypeName: 'Merchant Type',
      merchantAddress: 'Merchant Address',
      status: 'Status',
      operation: 'Operation',
      audit: 'Audit',
      recallAudit: 'Recall Audit',
      auditDialogTitle: 'Audit Information',
      auditStatusPlaceholder: 'Please audit',
      agree: 'Agree',
      reject: 'Reject',
      reason: 'Reason',
      reasonPlaceholder: 'Required, please fill in the reason',
      submit: 'Submit',
      cancel: 'Cancel',
      recallDialogTitle: 'Recall Audit',
      recallReason: 'Recall Reason',
      confirm: 'Confirm'
    }
  },
  zh: {
    auditEnterCommunity: {
      title: '商户审核',
      queryConditions: '查询条件',
      merchantName: '商户名称',
      communityName: '小区名称',
      auditStatus: '审核状态',
      search: '查询',
      more: '更多',
      hide: '隐藏',
      merchantType: '商户类型',
      contactNumber: '联系电话',
      merchantAudit: '商户审核',
      communityId: '小区ID',
      merchantTypeName: '商户类型',
      merchantAddress: '商户地址',
      status: '状态',
      operation: '操作',
      audit: '审核',
      recallAudit: '撤回审核',
      auditDialogTitle: '审核信息',
      auditStatusPlaceholder: '请审核',
      agree: '同意',
      reject: '拒绝',
      reason: '原因',
      reasonPlaceholder: '必填，请填写原因',
      submit: '提交',
      cancel: '取消',
      recallDialogTitle: '撤回审核',
      recallReason: '撤回原因',
      confirm: '确定'
    }
  }
}